import '@babel/polyfill'
import Vue from 'vue'
import './plugins/axios'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import Toasted from 'vue-toasted'

Vue.config.productionTip = false
Vue.use(Toasted, {
  position: 'bottom-right',
  duration: 5000,
  icon: 'done',
  theme: 'outline', //['primary', 'outline' , 'bubble']
  closeOnSwipe: true
})

// Some middleware to help us ensure the user is authenticated.
router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth) && (!router.app.$store.state.api_token || router.app.$store.api_token === 'null')) {
    //window.console.log("Not authenticated");
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else if (to.name == 'login' && router.app.$store.state.api_token) {
    router.push({
      name: 'validator'
    })
  } else {
    next()
  }
})


// Check local storage to handle refreshes
if (window.localStorage) {
  var localUser = window.localStorage.getItem('user') || null
  var localUserID = window.localStorage.getItem('user_id') || null
  var api_token = window.localStorage.getItem('access_token') || null
  var parkirisce = JSON.parse(window.localStorage.getItem('parkirisce')) || null
  var permissions = JSON.parse(window.localStorage.getItem('permissions')) || null


  /*console.log(localUser)
  console.log(localUserID)
  console.log(api_token)*/

  if ( (localUser && store.state.user !== localUser) && (api_token && store.state.api_token !== api_token) ) {
    store.commit('setUserID', localUserID)
    store.commit('setUser', localUser)
    store.commit('setToken', api_token)
    store.commit('setParkirisce', parkirisce)
    store.commit('setUserPermissions', permissions)
  }
}


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
